(function() {
    'use strict';

    angular
        .module('Services')
        .service('ManifestService', ManifestService);

    function ManifestService($http, $rootScope, Error, Request, Shipments, $cacheFactory, $q) {
        var service = {
            getNonManifestedShipments     : function(callback, errCallback, data){
                var filter = {
                    manifested: false,
                    bookingStatus: 'inprogress'
                }
                if (data) angular.extend(filter, data);
                Request.get({
                    url: ApiURLs.shipment.list,
                    successCallback: callback,
                    errorCallback: errCallback,
                    data: filter
                });
            },
            getManifestedShipments : function(callback, errCallback, data){
                var filter = {
                    manifested: true
                }
                if (data) angular.extend(filter, data);
                Request.get({
                    url: ApiURLs.shipment.list,
                    //successCallback: callback, //uncomment me when the API's UP.
                    successCallback: callback,
                    errorCallback: errCallback,
                    data: filter
                });
            },
            getManifests: function(callback, errCallback, data) {
                Request.get({
                    url: ApiURLs.manifest.getManifests,
                    successCallback: callback,
                    errorCallback: errCallback,
                    data: angular.extend({approved:true},data || {})
                });
            },
            getNonManifests: function(callback, errCallback, data) {
                Request.get({
                    url: ApiURLs.manifest.getManifests,
                    successCallback: callback,
                    errorCallback: errCallback,
                    data: angular.extend({approved:false},data || {})
                });
            },
            getScheduledPickUps: function (callback, errCallback, data){
                Request.get({
                    url: ApiURLs.manifest.getScheduledPickUps,
                    successCallback: callback,
                    errorCallback: errCallback,
                    data: data
                });
            },
            postScheduledPickUps: function (callback, errCallback) {
                Request.post({
                    url: ApiURLs.manifest.setScheduledPickUps,
                    successCallback: callback,
                    errorCallback: errCallback,
                });
            },
            manifestShipments: function (callback, errCallback, data){
                Request.post({
                    url: ApiURLs.manifest.postManifests,
                    method: 'POST',
                    successCallback: callback,
                    errorCallback: errCallback
                }, data);
            },
            downloadManifest: function (id, successCallback, errorCallback) {
                var fileName = 'manifest-document-' + id;
                Request.getFile({
                    fileName: fileName,
                    fileType: 'application/pdf',
                    url: ApiURLs.manifest.downloadManifest + '/' + id + '/document',
                    successCallback: successCallback,
                    errorCallback: errorCallback,
                    responseType: 'arraybuffer'
                });
            },
            getShipments: function (callback, errCallback, data, paramId){
                Request.get({
                    url: ApiURLs.manifest.root + '/' + paramId + '/shipments',
                    successCallback: callback,
                    errorCallback: errCallback,
                    data: data
                });
            },
            getFTPHistoricalInputs: function (successCallback, errorCallback, data) {
                Request.get({
                    url: ApiURLs.shipment.bookingFtp + 'history',
                    successCallback,
                    errorCallback,
                    data
                });
            },
            getFTPUnprocessedFiles: function (successCallback, errorCallback) {
                Request.get({
                    url: ApiURLs.shipment.bookingFtp + 'total-queue',
                    successCallback,
                    errorCallback,
                });
            },
            importFTPUnprocessedFilesNow: function () {
                Request.post({
                    url: ApiURLs.shipment.bookingFtp + 'import',
                    method: 'POST'
                });
            },
            downloadProofOfSignature:function(callback,errCallback,data){
                Request.get({
                    url: ApiURLs.fleets.downloadPOL,
                    successCallback:callback,
                    errorCallback:errCallback,
                    data
                });
            }
        };

        return service;
    };

})();



// WEBPACK FOOTER //
// ./js/services/manifestService.js